module.exports = __webpack_public_path__ + "img/upload-img-icon.ff730593.svg";